import { ReactNode } from 'react';
import './IconWrapper.css';

const IconWrapper = ({ children }: { children?: ReactNode[] }) => {
  return <div className="card-icon-wrapper">{children}</div>;
};

export default IconWrapper;
